import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { MainLayout } from '../components/MainLayout';
import { StudentOrgContractDialog } from 'src/components/StudentOrgContractDialog';
import { useSealedContract } from 'src/api/hooks/useContract';
import { useMe } from 'src/api/hooks/useAuth';
import { useLogout } from 'src/hooks/useLogout';
import { useStoreActions, useStoreState } from 'src/stores';
import { PageNotFound } from 'src/pages/PageNotFound/PageNotFound';
import { useFeatureFlagEnabled } from 'src/hooks/useFeatureFlags';

const ProtectedRoute = ({ component: Component, featureFlag, ...routerProps }: any) => {
  const [contractModalOpen, setContractModalOpen] = useState(false);

  const updateUser = useStoreActions(actions => actions.user.update);
  const setFeatureFlags = useStoreActions(actions => actions.auth.setFeatureFlag);

  const { companies } = useStoreState(state => state.user.data);

  const company = companies?.[0];

  const organizationType = company?.organizationType;

  const isLoggedIn = useStoreState(state => state.user.data.isLogedIn);

  const { logout } = useLogout();

  const isFeatureEnabled = useFeatureFlagEnabled(featureFlag);

  const [getMe] = useMe({
    onComplete: res => {
      if (!res?.managerProfile) {
        logout();

        return;
      }
      setFeatureFlags(res.featureFlags);
      updateUser({
        ...res.managerProfile,
        isLogedIn: true,
      });
    },
    onError: () => {
      logout();

      return;
    },
  });

  const [getAllSealedContracts] = useSealedContract({
    onComplete: res => {
      if (!res) return;

      if (res.length === 0) {
        setContractModalOpen(true);
      }
    },
  });

  useEffect(() => {
    if (isLoggedIn) {
      getMe();
      getAllSealedContracts();
    }
  }, [isLoggedIn]);

  if (isLoggedIn && featureFlag && !isFeatureEnabled) {
    return <Route component={PageNotFound} />;
  }

  if (!company || !organizationType) {
    return <Redirect to="/auth" />;
  }

  return (
    <>
      <MainLayout>
        <Route
          {...routerProps}
          render={props => (isLoggedIn ? <Component {...props} /> : <Redirect to="/auth" />)}
        />
      </MainLayout>
      <StudentOrgContractDialog
        open={contractModalOpen}
        setOpen={setContractModalOpen}
        organizationType={organizationType}
      />
    </>
  );
};

export { ProtectedRoute };
